<template>
    <div class="plan">
        <div class="header">
            <el-row>
                <el-col>
                    <div class="page-title bold fnt-lg dark text-left">
                        План по сотрудникам
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row class="mb10">
                <el-col :span="2" class="ml-15 plan-top-filter-year">
                    <el-date-picker
                        v-model="selectedYear"
                        type="year"
                        value-format="yyyy"
                        :clearable="false"
                        :editable="false"
                        @change="updateEmployersWithPlans"
                    />
                </el-col>
                <el-col :span="4" class="text-center bold plan-top-filter-fired">
                    <span>Показывать уволенных</span>
                    <el-checkbox v-model="showFired" @change="updateEmployersWithPlans" />
                </el-col>
            </el-row>
            <el-row v-loading="loading">
                <el-col>
                    <div class="table">
                        <div class="table-header">
                            <div class="table-row" v-if="employers.length">
                                <div class="table-cell title-cell bold">
                                    Офис
                                </div>
                                <div class="table-cell title-cell bold">
                                    Должность
                                </div>
                                <div class="table-cell title-cell bold">
                                    Сотрудник
                                </div>
                                <div class="table-cell title-month bold" v-for="month in months" :key="month">
                                    {{ month }}
                                </div>
                            </div>
                        </div>
                        <div class="table-body">
                            <div v-for="employer in employers" :key="employer.key" :class="['table-row', isFiredEmployerClass(employer.date_fired)]">
                                <div class="table-cell title-cell">
                                    {{ getOfficeName(employer.plans[0]['office_id']) }}
                                </div>
                                <div class="table-cell title-cell">
                                    {{ employer.position.name }}
                                </div>
                                <div class="table-cell title-cell">
                                    <span class="mr8">
                                        {{ employer.full_name }}
                                    </span>
                                    <el-button
                                        class="save-button"
                                        size="mini"
                                        type="warning"
                                        v-if="employer.changed"
                                        @click="updateEmployerPlans(employer.key)"
                                    >
                                        сохранить
                                    </el-button>
                                </div>
                                <template v-if="employer.plans.length">
                                    <div
                                        v-for="plan in employer.plans"
                                        :key="plan.id"
                                        @click="showEditBlock($event, employer, plan)"
                                        :class="[
                                            'table-cell plan-cell',
                                            {'changed-cell': plan.changed},
                                            {'pointer': employer.editable}
                                        ]"
                                    >
                                        {{ plan.value ? plan.value.toLocaleString() : '' }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div
                                        v-for="month in months"
                                        :key="month"
                                        class="table-cell"
                                    >
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div
                        class="edit-block"
                        v-if="isEditBlockVisible"
                        :style="editBlockStyle"
                    >
                        <vue-autonumeric
                            v-model="selectedPlan.value"
                            :options="numericOptions"
                            @keydown.native.enter="changePlanValue"
                            @keydown.native.esc="hideEditBlock"
                            v-on-clickaway="saveHideEditBlock"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import '@/assets/styles/plan.scss';
import VueAutonumeric from '@/components/autonumeric/VueAutonumeric';
import { eventBus } from '@/common/eventBus';
import moment from 'moment';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'EmployerPlan',
    components: {
        VueAutonumeric
    },
    mixins: [
        clickaway
    ],
    data() {
        return {
            showFired: 0,
            loading: false,
            isEditBlockVisible: false,
            editBlockStyle: {
                top: 0,
                left: 0
            },
            selectedPlan: {},
            selectedPlanOldValue: null,
            selectedEmployerKey: null,
            selectedYear: moment().format('YYYY'),
            months: [
                'Январь',
                'Февраль',
                'Март',
                'Апрель',
                'Май',
                'Июнь',
                'Июль',
                'Август',
                'Сентябрь',
                'Октябрь',
                'Ноябрь',
                'Декабрь'
            ],
            numericOptions: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '9999999',
                isCancellable: true,
                emptyInputBehavior: 'null',
                modifyValueOnWheel: false
            }
        };
    },
    computed: {
        employers() {
            const employers = this.$store.state.analytics.employersWithPlans;
            employers.forEach((item) => { item.key = item.id + '-' + item.plans[0].office_id; });
            return employers;
        }
    },
    methods: {
        updateEmployersWithPlans() {
            this.getEmployersWithPlans();
        },
        showEditBlock(event, employer, plan) {
            this.saveEditedPlan();
            if (!employer.editable) {
                return;
            }
            this.isEditBlockVisible = true;
            if (this.isEditBlockVisible) {
                this.editBlockStyle.top = `${event.target.offsetTop - 14}px`;
                this.editBlockStyle.left = `${event.target.offsetLeft + 1}px`;
                this.selectedPlan = Object.assign({}, plan);
                this.selectedPlanOldValue = this.selectedPlan.value;
                this.selectedEmployerKey = employer.key;
                this.$nextTick(() => {
                    eventBus.$emit('autonumeric-focus-input');
                });
            }
        },
        hideEditBlock() {
            this.selectedPlan = {};
            this.isEditBlockVisible = false;
        },
        saveHideEditBlock($event) {
            if (this.isEditBlockVisible && !$event.target.classList.contains('plan-cell')) {
                this.saveEditedPlan();
                this.hideEditBlock();
            }
        },
        saveEditedPlan() {
            if (
                Object.keys(this.selectedPlan).length &&
                this.selectedPlan.value &&
                this.selectedPlan.value !== this.selectedPlanOldValue
            ) {
                this.changePlanValue();
                this.isEditBlockVisible = false;
            }
        },
        changePlanValue() {
            this.$store.commit('analytics/changePlanValue',
                {
                    employerKey: this.selectedEmployerKey,
                    changedPlan: this.selectedPlan
                });
            this.isEditBlockVisible = !this.isEditBlockVisible;
            this.selectedPlan = {};
        },
        getOfficeName(officeId) {
            return this.$store.getters['references/getOfficeNameById'].filter(item => item.id === officeId)[0].name;
        },
        async getEmployersWithPlans() {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/getEmployersWithPlans', {
                    year: this.selectedYear,
                    showFired: this.showFired
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        async updateEmployerPlans(employerKey) {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/updateEmployerPlans', { employerKey });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        isFiredEmployerClass(dateFired) {
            return dateFired ? 'fired_employer' : '';
        }
    },
    mounted() {
        this.getEmployersWithPlans();
    }
};
</script>
